import {Directive, ElementRef, Output, EventEmitter, HostListener} from '@angular/core';

@Directive({
    selector: '[clickOutside]'
})
export class ClickoutsideDirective {

    constructor(private _elementRef: ElementRef) {
        console.log('init this shit');
    }

    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();

    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {

        // console.log(event);
        if (!targetElement) {
            return;
        }

        // const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        //
        // if (!clickedInside) {


        // console.log(targetElement.classList['value']);

        if (targetElement.classList['value'].indexOf('ellipses') > -1) {
        } else {
            // console.log('emit the event');
            this.clickOutside.emit(event);
        }

        // }
    }

}





// WEBPACK FOOTER //
// ./src/app/directives/click-outside.directive.ts